import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  Button,
  Alert,
  DialogActions,
} from '@mui/material';
import { Auth } from 'aws-amplify';

const ChangePasswordDialog = ({ user, open, handleClose }) => {
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');

  const submitPassword = async () => {
    try {
      await Auth.changePassword(user, password, newPassword);
      handleClose();
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <DialogContentText>
          To change your password, please enter your old and new password here.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="oldPassword"
          label="Old Password"
          type="password"
          fullWidth
          variant="standard"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <TextField
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          autoFocus
          margin="dense"
          id="newPassword"
          label="New Password"
          type="password"
          fullWidth
          variant="standard"
        />
        {error && <Alert severity="error">{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={submitPassword}>Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
